// extracted by mini-css-extract-plugin
module.exports = {"change-password-input":"style_change-password-input__ufm1n","input":"style_input__dmL8_"};